var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:'s-icon ' + _vm.size,attrs:{"src":require('@/assets/icons/' + _vm.iconName + '.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }